import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _excluded = ["onSuccess"],
  _excluded2 = ["mutateAsync"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { setAlert, setSuccessAlert } from 'actions/alerts';
import { playlistQueryKeys } from 'actions/playlists';
import { contentQueryKeys } from 'actions/content';
import api from 'utils/api';
import toArray from 'utils/toArray';
import { ASSET_TYPES } from 'utils/asset/constants';
function restoreContent(_x) {
  return _restoreContent.apply(this, arguments);
}
function _restoreContent() {
  _restoreContent = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var id, type;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          id = _ref.id, type = _ref.type;
          if (ASSET_TYPES.includes(type)) {
            type = 'asset';
          }
          return _context.abrupt("return", api('patch', "/api/query/".concat(type, "/*"), {
            filter: {
              id: id
            }
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _restoreContent.apply(this, arguments);
}
export function useRestoreContent() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _onSuccess = _ref2.onSuccess,
    options = _objectWithoutProperties(_ref2, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var queryClient = useQueryClient();
  var _useMutation = useMutation(_objectSpread(_objectSpread({
      mutationFn: restoreContent
    }, options), {}, {
      onSuccess: function onSuccess(data, variables) {
        return Promise.all([queryClient.invalidateQueries({
          queryKey: contentQueryKeys.contentLogs()
        }), (variables === null || variables === void 0 ? void 0 : variables.type) === 'playlist' && queryClient.invalidateQueries({
          queryKey: playlistQueryKeys.allPlaylists
        })]).then(function () {
          setSuccessAlert({
            title: t((variables === null || variables === void 0 ? void 0 : variables.type) === 'playlist' ? 'alert_playlist_restored_successfully' : 'alert_content_restored_successfully', {
              count: toArray(variables.id).length
            })
          });
          _onSuccess === null || _onSuccess === void 0 || _onSuccess();
        });
      },
      onError: function onError() {
        setAlert({
          title: t('alert_content_restored_error')
        });
      }
    })),
    mutateAsync = _useMutation.mutateAsync,
    result = _objectWithoutProperties(_useMutation, _excluded2);
  return _objectSpread(_objectSpread({}, result), {}, {
    restoreContent: mutateAsync
  });
}
export default useRestoreContent;